export default "__VITE_ASSET__BZX6Nook__"